/**
 *
 * FBFormsPreviewAnswerTab
 *
 */

import React, { memo, useCallback, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
import CustomIcons from 'components/CustomIcons';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

// antd component
import { Result, Button } from 'antd';

// layout components
import Preloader from 'components/Preloader';
import ErrorBoundary from 'engine/ErrorBoundary';

// Communication components
import {
  FBAnswersTabHeader,
} from 'components/Communications';
// inner components
import { FBFormsPreviewAnswer } from './components';



function FBFormsPreviewAnswerTab({
  type,
  loading,
  values,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-forms-group-preview', 'tcf-fb-group-preview', 'tcf-fb-group-answer-tab', className);

  const [amount, setAmount] = useState(values?.data?.length || 0);
  const [currentStep, setCurrentStep] = useState(0);
  const [answersList, setAnswersList] = useState(values?.data || []);


  // Refresh current value based on parent`s states
  useEffect(() => {
    if (!!values && Object.keys(values)?.length > 0) {
      setAnswersList(values?.data);
      setAmount(values?.answersAmount);
    }
  }, [values]);

  const onChangeStep = useCallback(type => {
    switch (type) {
      case 'prev':
        const prevStep = (currentStep - 1) != 0 ? currentStep - 1 : 0;
        setCurrentStep(prevStep);
        break;
      case 'next':
        const nextStep = currentStep < amount - 1 ? currentStep + 1 : currentStep;
        setCurrentStep(nextStep);
        break;
      default:
        setCurrentStep(0);
        break;
    }
  }, [currentStep, amount]);

  const stepsNabigation = useMemo(() => {
    let stdName = ''
    if (answersList[currentStep]?.studentData?.length > 0) {
      const { description } = answersList[currentStep]?.studentData[0];
      stdName = `${description?.firstname} ${description?.lastname}`;
    }
    return (
      <div className='tcf-fb-group-answer-tab__navigation'>
        <div className="navigation">
          <Button disabled={currentStep == 0} onClick={() => onChangeStep('prev')} ><LeftOutlined /></Button>
          <Button disabled={currentStep >= amount - 1} onClick={() => onChangeStep('next')} ><RightOutlined /></Button>
        </div>
        <div className="amount-wrapper">{`${currentStep + 1} / ${amount}`}</div>
        {stdName && (
          <span className="student-name">: {stdName}</span>
        )}

      </div>
    );
  }, [currentStep, amount]);

  return !!values && (
    <div {...rest} className={childClassNames}>
      <ErrorBoundary>
        <div className='tcf-fb-group-answer-tab__wrapper'>
          {loading && <Preloader />}
          {!loading && answersList?.length > 0 && (
            <>
              <FBAnswersTabHeader key="form-preview-header" data={answersList} />
              <div className="tcf-fb-group-answer-tab__content">
                {stepsNabigation}
                <FBFormsPreviewAnswer
                  key={`form-answer-tab-${currentStep}`}
                  values={answersList[currentStep]}
                />
              </div>
            </>
          )}
          {!loading && answersList?.length == 0 && (
            <>
              <Result title="Malheureusement, il n'y a pas encore de réponses." />
            </>
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
}

FBFormsPreviewAnswerTab.defaultProps = {
  type: 'forms',
  loading: false,
};
FBFormsPreviewAnswerTab.propTypes = {
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.array])
};

export default memo(FBFormsPreviewAnswerTab);
